/**
 * Approximate character width as a ratio of font size
 * Used to estimate how many characters fit in a given width
 */
const CHAR_WIDTH_RATIO = 0.5;

/**
 * Minimum font size in pixels for treemap text
 * Ensures text remains readable even in small cells
 */
const MIN_FONT_SIZE = 10;

/**
 * Maximum font size in pixels for treemap text
 * Prevents text from becoming too large in big cells
 */
const MAX_FONT_SIZE = 14;

/**
 * Divisor used to calculate font size from cell width
 * Formula: fontSize = width / FONT_SIZE_DIVISOR
 */
const FONT_SIZE_DIVISOR = 8;

/**
 * Additional vertical spacing between text lines in pixels
 * Creates proper line height for multi-line text
 */
const LINE_SPACING = 2;

/**
 * Padding around text content in pixels
 * Provides breathing room between text and cell borders
 */
const TEXT_PADDING = 4;

/**
 * Minimum cell width in pixels required to render text
 * Below this width, text is hidden to avoid overcrowding
 */
const MIN_CELL_WIDTH = 50;

/**
 * Minimum cell height in pixels required to render text
 * Below this height, text is hidden to avoid overcrowding
 */
const MIN_CELL_HEIGHT = 40;

/**
 * Border stroke width for treemap cells in pixels
 * Creates visual separation between adjacent cells
 */
const STROKE_WIDTH = 2;

export {
  CHAR_WIDTH_RATIO,
  FONT_SIZE_DIVISOR,
  LINE_SPACING,
  MAX_FONT_SIZE,
  MIN_CELL_HEIGHT,
  MIN_CELL_WIDTH,
  MIN_FONT_SIZE,
  STROKE_WIDTH,
  TEXT_PADDING,
};
